import { IsObject, IsOptional, IsString, MaxLength } from 'class-validator';
import { Data } from '../data';

export class CreateAuditLogDto {
  @IsString()
  tenantId!: string;

  @IsString()
  entityType!: string;

  @IsString()
  entityId!: string;

  /** Empty for a record-level entry, e.g. "authorized". */
  @IsOptional()
  @IsString()
  fieldName?: string | null;

  @IsOptional()
  beforeValue?: string | null;

  @IsOptional()
  afterValue?: string | null;

  /** A user id, or `SYSTEM_ACTOR` when no user made the change. */
  @IsString()
  changedBy!: string;

  @IsOptional()
  @IsString()
  reason?: string | null;

  /** What happened, e.g. "payment.issued". */
  @IsOptional()
  @IsString()
  @MaxLength(64)
  action?: string | null;

  /** The record the entry belongs to, e.g. the claim of a payment, so it can be listed with it. */
  @IsOptional()
  @IsString()
  @MaxLength(64)
  scopeType?: string | null;

  @IsOptional()
  @IsString()
  scopeId?: string | null;

  @IsOptional()
  @IsObject()
  data?: Data | null;
}
